import { IInitialState } from 'store/models';
import { moduleStateSelector } from './moduleStateSelector';

export function errorSelector(state: IInitialState) {
	return moduleStateSelector(state).error;
}
